import React, { useEffect, useState } from 'react';
import PageLayout from 'components/layouts/PageLayout';
import { useStoreWrapper } from 'stores/StoreHelper';
import LocaleLists from 'components/languageSettings/LocaleLists';
import Box from 'components/layouts/Box';
import NewButton from 'components/input/NewButton';
import { Row } from 'saladsoft-primitive';
import ServiceHelper from 'stores/ServiceHelper';
import { AdminRegionDto, AdminSystemLocaleDto } from 'services/data-contracts';
import styled from 'styled-components';
import { InnerGroup } from 'components/layouts/CommonForm';
import { InnerSection } from 'components/layouts/CommonForm';
import Text from 'components/commons/Text';
import { toast } from 'react-toastify';
import IconButton from 'controls/IconButton';
import { useLocale } from 'providers/LocalProvider';
import { useStateContext } from 'providers/usePageState';
import RegionForm from 'components/pages/region/RegionForm';
import { RegionModel } from 'types/CommonTypes';

const RegionSettingsPage = () => {
  const { uiStore } = useStoreWrapper();
  const { initLocales } = useLocale();
  const { broadcast } = useStateContext();
  const [regions, setRegions] = useState<Array<AdminRegionDto>>([]);

  const handleRegionChange = (region?: RegionModel) => {
    uiStore?.modal.show({
      title: '지역설정',
      style: {
        width: '500px',
        maxHeight: '70vh',
        height: 'auto',
      },
      children: (
        <div style={{ padding: 20 }}>
          <RegionForm
            onSave={() => {
              getRegion();
            }}
            region={region}
          />
        </div>
      ),
    });
  };

  const getRegion = () => {
    ServiceHelper.adminRegionService?.getRegions1().then((res) => {
      setRegions(res.data);
    });
  };

  const handleDeleteRegion = (region: RegionModel) => {
    uiStore?.confirm.show({
      title: '지역삭제',
      message: '해당 지역을 삭제하시겠습니까?',
      onConfirmed: () => {
        ServiceHelper?.adminRegionService?.deleteRegion(region?.id as number).then((res) => {
          if (res.status < 300) {
            toast.success('지역 삭제가 완료되었습니다.');
            setRegions(regions.filter((lang) => lang.id !== region.id));
            getRegion();
          } else {
            toast.error('언어 삭제에 실패하였습니다.');
          }
        });
      },
    });
  };

  useEffect(() => {
    getRegion();
  }, []);

  return (
    <PageLayout
      title="지역설정"
      actionButton={
        <NewButton
          onClick={() => {
            handleRegionChange();
          }}
        >
          지역추가
        </NewButton>
      }
    >
      <InnerSection style={{ minHeight: 'unset' }}>
        <InnerGroup>
          <div>
            <Text type="H3">필터링에 사용할 지역 설정</Text>
            <Text type="H4" buttonRole="DESCRIPTION" style={{ margin: '10px 0' }}>
              지역설정은 필터링에 사용됩니다.
            </Text>
          </div>

          <div>
            <Row gap={10} justifyContent="flex-start" flexWrap="wrap" marginTop={0}>
              {regions.map((region) => (
                <LanguageItem
                  onClick={() => {
                    handleRegionChange(region);
                  }}
                >
                  <span>{region.localizedName?.ko}</span>
                  <IconButton
                    type="delete"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteRegion(region);
                    }}
                    style={{ display: 'flex' }}
                  />
                </LanguageItem>
              ))}
            </Row>
          </div>
        </InnerGroup>
      </InnerSection>

      {/* 언어 설정 관련 컨텐츠 */}
    </PageLayout>
  );
};

const LanguageItem = styled.div`
  width: 100%;
  max-width: 200px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #cccccc;
  border-radius: 10px;
  padding: 10px;
  cursor: pointer;
`;

export default RegionSettingsPage;
